import React from 'react';
import ClassNames from 'classnames';
import {
  Paper,
  IconButton,
  Dialog,
  FlatButton,
  RaisedButton,
  Styles,
  TextField
} from 'material-ui';
import { AppActions } from 'actions';
import { GridRow, GridCell } from 'components/Grid/Grid';
import { IntlMixin, FormattedRelative } from 'react-intl';
import ProfileImage from 'components/Widgets/ProfileImage';
import Post from 'services/Post';
import VideoPreview from 'components/Widgets/VideoPreview';
import update from 'react/lib/update';
import MessageService from 'services/Message';

import Linkify from 'react-linkify';
import PageModule from 'components/PageModule';
import DialogPortal from 'components/DialogPortal';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import SteelCompass from 'services/SteelCompass';

const hoverColor = Colors.Colors.grey[500].material;
const { Component, PropTypes } = React;

const { Spacing } = Styles;

const styles = {
  message: {
    adminButton: {
      margin: Spacing.desktopGutterMini / 4,
      padding: Spacing.desktopGutterMini / 4,
      minWidth: 24,
      border: Spacing.desktopGutterMini / 4,
      lineHeight: '24px'
    }
  },
  deleteButton: {
    button: {
      lineHeight: `${36}px`,
      width: 36,
      height: 36,
      minWidth: 36
    },
    icon: {
      margin: 6
    }
  },
  editBox: {
    borderRadius: 2,
    border: `solid 1px ${Colors.Colors.grey[300].material}`,
    backgroundColor: Colors.Colors.grey[100].material,
    padding: Spacing.desktopGutterMini / 2
  },
  ago: {
    color: 'rgba(0, 0, 0, 0.4)',
    marginLeft: '4px',
  },
  toolbarGroup: {
    margin: 2,
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: Colors.Colors.grey[300].material
  },
  iconButton: {
    lineHeight: `${36}px`,
    backgroundColor: Colors.Colors.fullWhite,
    margin: 0,
    padding: 6,
    borderRadius: 2,
    width: 36,
    height: 36,
    verticalAlign: 'middle'
  },
  icon: {
    margin: 6
  }
};

var MessageControls = React.createClass({
  mixins: [IntlMixin],
  propTypes: {
    reply: React.PropTypes.bool,
    follow: React.PropTypes.bool,
    created: React.PropTypes.string,
    onReply: React.PropTypes.func.isRequired
  },
  getDefaultProps() {
    return {
      reply: true,
      follow: true
    };
  },
  _onTouchTap() {
    this.props.onReply();
  },
  follow() {
    this.props.onFollow();
  },
  unfollow() {
    this.props.onUnFollow();
  },
  edit() {
    this.props.onEdit();
  },
  delete() {
    this.props.onDelete();
  },
  render() {
    let replyButton, followButton, editButton, deleteButton, created;
    created = new Date(this.props.created.split(' ').join('T') + 'Z');

    if (this.props.reply) {
      replyButton = (
        <IconButton
          tooltip={this.getIntlMessage('Reply')}
          tooltipPosition={this.props.editor ? 'top-center' : 'bottom-center'}
          style={styles.iconButton}
          onTouchTap={this._onTouchTap}
        >
          <Icons.ContentReply style={styles.icon} />
        </IconButton>
      ); //<FlatButton style={styles.message.adminButton} label={this.getIntlMessage('Reply')} onTouchTap={this._onTouchTap}/>;
    }
    if (this.props.follow) {
      if (this.props.isFollowing) {
        followButton = (
          <IconButton
            tooltip={this.getIntlMessage('Unfollow')}
            style={styles.iconButton}
            onTouchTap={this.unfollow}
          >
            <Icons.ActionFavoriteBorder style={styles.icon} />
          </IconButton>
        );
      } else {
        followButton = (
          <IconButton
            tooltip={this.getIntlMessage('Follow')}
            style={styles.iconButton}
            onTouchTap={this.follow}
          >
            <Icons.ActionFavorite style={styles.icon} />
          </IconButton>
        );
        // <FlatButton onTouchTap={this.follow} style={styles.message.adminButton} label={this.getIntlMessage('Follow')}/>;
      }
    }
    if (this.props.edit || this.props.editor) {
      editButton = (
        <IconButton
          tooltip={this.getIntlMessage('Edit')}
          tooltipPosition="top-center"
          style={styles.iconButton}
          onTouchTap={this.edit}
        >
          <Icons.EditorModeEdit style={styles.icon} />
        </IconButton>
      );
      //<FlatButton onTouchTap={this.edit} style={styles.message.adminButton} label={this.getIntlMessage('Edit')}/>;
    }
    if (this.props.delete || this.props.editor) {
      deleteButton = (
        <IconButton
          tooltip={this.getIntlMessage('Delete')}
          tooltipPosition="top-center"
          style={styles.iconButton}
          onTouchTap={this.delete}
        >
          <Icons.ActionDelete style={styles.icon} />
        </IconButton>
      );
      //<FlatButton onTouchTap={this.delete} style={styles.message.adminButton} label={this.getIntlMessage('Delete')}/>;
    }

    return (
      <GridRow fluid={true}>
        <GridCell size={6}>
          <span className={'author'}>{this.props.author}</span>
          <span style={styles.ago}>
            <FormattedRelative value={created} />
          </span>
        </GridCell>
        <GridCell size={6} className={'actions'} style={styles.toolbarGroup}>
          {editButton}
          {deleteButton}
          {replyButton}
          {followButton}
        </GridCell>
      </GridRow>
    );
  }
});

var MessageComposer = React.createClass({
  mixins: [IntlMixin],
  getInitialState() {
    return {
      message: this.props.message || '',
      uploads: this.props.files || []
    };
  },
  propTypes: {
    sendButton: React.PropTypes.bool,
    onChange: React.PropTypes.func,
    onSend: React.PropTypes.func,
    onAttach: React.PropTypes.func,
    saveOnBlur: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      sendButton: true
    };
  },
  _onSend() {
    if (this.props.onSend) {
      this.props.onSend(this.state.message, this.state.uploads);
    } else {
      Post.create(
        this.props.id,
        this.state.message,
        this.state.uploads,
        response => {}
      );
      this.clear();
    }
  },
  _onChangeMessage(event) {
    this.setState({ message: event.target.value });
    if (this.props.onChange) {
      this.props.onChange(event.target.value, this.state.uploads);
    }
  },
  getMessage() {
    return this.state.messsage;
  },
  getUploads() {
    return this.state.uploads;
  },
  clear() {
    this.setState({ message: '', uploads: [] });
  },
  _onAttach(e) {
    if (this.props.onAttach) {
      SteelCompass.upload(e.target.files, {
        encoded: this.props.encoded,
        progress: event => {},
        success: response => {
          var uploads = [];
          response.data.forEach(data => {
            data.file.title = data.file.name;
            uploads.push(data.file);
          });
          uploads = this.state.uploads.concat(uploads);
          this.props.onAttach(uploads);
          this.setState({ uploads });
          if (this.props.onChange) {
            this.props.onChange(this.state.message, uploads);
          }
          //data.
        }
      });
    } else {
      let i = 0;
      this.setState({ progress: 0, progressing: true });
      SteelCompass.upload(e.target.files, {
        encoded: this.props.encoded,
        progress: event => {},
        success: response => {
          i++;
          if (i > 1) {
            return
          }
          this.setState({ progressing: false, amount: 0 });
          if (response.data) {
            var uploads = [];
            response.data.forEach(data => {
              data.file.title = data.file.name;
              uploads.push(data.file);
            });
            uploads = this.state.uploads.concat(uploads);
            this.setState({ uploads });
            if (this.props.onChange) {
              this.props.onChange(this.state.message, uploads);
            }
          }
        }
      });
    }
  },
  _removeUpload(uploadId) {
    var foundIndex = null;
    this.state.uploads.forEach((upload, index) => {
      if (upload.id === uploadId) {
        foundIndex = index;
      }
    });
    if (foundIndex !== null) {
      this.state.uploads.splice(foundIndex, 1);
      this.setState({ uploads: this.state.uploads });
      if (this.props.onChange) {
        this.props.onChange(this.state.message, this.state.uploads);
      }
    }
  },
  render() {
    var uploads, sendButton;
    if (this.state.uploads.length > 0) {
      uploads = (
        <div className="uploads">
          {this.state.uploads.map(upload => {
            return (
              <div key={upload.id} className="upload-file">
                <RaisedButton
                  href={upload.url}
                  linkButton={true}
                  label={upload.title}
                  target="_blank"
                />
                <RaisedButton
                  tooltip={this.getIntlMessage('Delete')}
                  style={styles.deleteButton.button}
                  onTouchTap={this._removeUpload.bind(this, upload.id)}
                >
                  <Icons.ActionDelete
                    style={styles.deleteButton.icon}
                    color={Colors.Colors.red[200].material}
                    hoverColor={hoverColor}
                  />
                </RaisedButton>
              </div>
            );
          })}
        </div>
      );
    }
    let padding = Spacing.desktopGutterMini / 2;
    if (this.props.sendButton) {
      sendButton = (
        <GridCell size={6}>
          <div style={{ margin: `${padding}px ${padding}px ${padding}px 0` }}>
            <RaisedButton
              fullWidth={true}
              label={this.getIntlMessage('Send')}
              onTouchTap={this._onSend}
            />
          </div>
        </GridCell>
      );
    }
    return (
      <div className={'post-wrapper post-reply'}>
        {!this.props.noUser && (
          <div className="profile">
            <ProfileImage author={this.props.author} />
          </div>
        )}
        <div className={'post'}>
          <div
            className={ClassNames({
              'arrow-box': !this.props.noUser,
              'message-box': this.props.noUser
            })}
          >
            {this.props.author && this.props.author.displayName}
            <TextField
              fullWidth={true}
              value={this.state.message}
              multiLine={true}
              floatingLabelText={this.getIntlMessage(
                this.props.noUser
                  ? 'post.describeDiscussion'
                  : 'post.writeAComment'
              )}
              onChange={this._onChangeMessage}
              onBlur={this.props.saveOnBlur}
            />
          </div>
          <GridRow>
            {sendButton}
            <GridCell size={6}>
              <div
                style={{ margin: `${padding}px 0 ${padding}px ${padding}px` }}
              >
                <RaisedButton
                  fullWidth={true}
                  className="file-upload"
                  label={this.getIntlMessage('attachFile')}
                >
                  <input
                    onChange={this._onAttach}
                    type="file"
                    accept="*/*"
                    multiple
                  />
                </RaisedButton>
              </div>
            </GridCell>
          </GridRow>
          {uploads}
        </div>
      </div>
    );
  }
});

var Message = React.createClass({
  getInitialState() {
    return {
      reply: this.props.replyEnabled,
      messages: this.props.messages.reverse(),
      files: this.props.files,
      mode: 'detail',
      body: this.props.body,
      confirmDialog: false
    };
  },
  contextTypes: {
    getIntlMessage: PropTypes.func
  },
  propTypes: {
    author: React.PropTypes.object,
    created: React.PropTypes.string,
    depth: React.PropTypes.number,
    messages: React.PropTypes.array,
    files: React.PropTypes.array,
    objects: React.PropTypes.object,
    body: React.PropTypes.string,
    id: React.PropTypes.number,
    isFollowing: React.PropTypes.bool,
    replyEnabled: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      depth: 0,
      isFollowing: false,
      body: '',
      messages: [],
      user: {},
      author: {},
      files: [],
      replyEnabled: false
    };
  },
  _onReply() {
    this.setState({ reply: !this.state.reply });
  },
  _onSend(message, uploads) {
    this.props.gaTracking();
    let i = 0;
    Post.create(this.props.id, message, uploads, response => {
      if (response.data) {
        if (i > 0) {
          return
        }
        i++;
        this.setState(
          update(this.state, {
            messages: {
              $push: [response.data]
            }
          })
        );
        this.refs.composer.clear();
      } else if (response.isError && response.errMsg) {
        MessageService.info(response.errMsg);
      }
    });
  },
  _onAttach(files) {},
  isImage(url) {
    url = url || '';
    return url.match(/\.(jpeg|jpg|gif|png)$/) !== null;
  },
  isVideo(url) {
    url = url || '';
    return url.match(/\.(mp4|ogv|ogg)$/) !== null;
  },
  onFollow() {
    if (this.props.onFollowChild) {
      this.props.onFollowChild(this.props.id);
    }
  },
  onSortMessage(){
    const messages = this.state.messages.reverse();
    this.setState({ messages });
  },
  onUnFollow() {
    if (this.props.onUnfollowChild) {
      this.props.onUnfollowChild(this.props.id);
    }
  },
  onEdit() {
    this.setState({ mode: 'edit' });
  },
  onDelete() {
    this.setState({ confirmDialog: true });
  },
  cancelDelete() {
    this.setState({ confirmDialog: false });
  },
  deleteConfirm() {
    if (this.props.onDeleteChild) {
      this.props.onDeleteChild(this.props.id);
    }
  },
  followChild(id) {
    const messages = this.state.messages.slice().map(message => {
      if (message.id === id) {
        return {
          ...message,
          isFollowing: true
        };
      }
      return message;
    });
    Post.follow(id);
    this.setState({ messages });
  },
  unfollowChild(id) {
    const messages = this.state.messages.slice().map(message => {
      if (message.id === id) {
        return {
          ...message,
          isFollowing: false
        };
      }
      return message;
    });
    Post.unfollow(id);
    this.setState({ messages });
  },
  deleteChild(id) {
    const messages = this.state.messages.slice().filter(message => {
      return message.id !== id;
    });
    Post.delete(id);
    this.setState({ messages });
  },
  onSave(body) {
    Post.update(this.props.id, body, this.state.files);
    this.setState({ mode: 'detail', body });
  },
  onRemove(id, processChildren = false) {
    SteelCompass.request('post', 'removeUploaded', { id, processChildren }).then(
      res => {
        if (res) {
          AppActions.translatableMessage('tasks.fileRemoved');
        } else {
          AppActions.translatableMessage('tasks.fileNotRemoved');
        }
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  render() {
    var messages,
      composer,
      controls,
      downloads,
      depth = this.props.depth + 1;
    if (this.state.messages.length > 0) {
      messages = (
        <div className={ClassNames({ 'deep-responses': depth > 1 })}>
          {this.state.messages.map(message => {
            var files = [],
              fileObjects,
              fileIds;
            if (message.objects) {
              (fileObjects = message.objects.files || []),
                (fileIds = message.objects.file || []);
              for (var i = 0; i < fileObjects.length; i++) {
                files.push({
                  id: fileObjects.id || fileIds[i],
                  title: fileObjects[i].title,
                  url: fileObjects[i].url
                });
              }
            } else {
              files = message.files;
            }

            message.author = message.author || { avatar: '', id: 0, name: '' };
            return (
              <div>
                <Message
                  onFollowChild={this.followChild}
                  onUnfollowChild={this.unfollowChild}
                  onDeleteChild={this.deleteChild}
                  editor={this.props.editor}
                  user={this.props.user}
                  depth={depth}
                  key={message.id}
                  messages={message.children}
                  body={message.body}
                  id={message.id}
                  isFollowing={message.isFollowing}
                  gaTracking={this.props.gaTracking}
                  created={message.created}
                  author={message.author}
                  files={files}
                />
                {!!this.props.author && this.props.author.id === this.props.user.id &&
                  !!files.length && (
                    <RaisedButton
                      style={{
                        marginLeft: 70,
                        width: 'calc(100% - 70px)',
                        marginBottom: 16,
                        minWidth: 'auto'
                      }}
                      onClick={() => this.onRemove(message.id)}
                      fullWidth
                      label="Remove attached files"
                    />
                  )}
              </div>
            );
          })}
        </div>
      );
    }
    if (this.state.reply) {
      composer = (
        <MessageComposer
          ref="composer"
          editor={this.props.editor}
          author={this.props.user}
          onSend={this._onSend}
        />
      );
    }
    if (depth > 1 && this.state.mode !== 'edit') {
      controls = (
        <MessageControls
          mode={this.state.mode}
          onSave={this.onSave}
          onDelete={this.onDelete}
          onFollow={this.onFollow}
          onUnFollow={this.onUnFollow}
          onEdit={this.onEdit}
          onReply={this._onReply}
          editor={this.props.editor}
          author={this.props.author && this.props.author.name}
          created={this.props.created}
          reply={depth <= 2 && this.props.author && this.props.author.id !== this.props.user.id}
          follow={this.props.author && this.props.author.id !== this.props.user.id}
          edit={this.props.author && this.props.author.id === this.props.user.id}
          delete={this.props.author && this.props.author.id === this.props.user.id}
          isFollowing={this.props.isFollowing}
        />
      );
    }

    if (this.props.files && this.props.files.length > 0) {
      var index = 0;
      downloads = (
        <div className="download-files">
          {this.props.files.map(download => {
            index++;
            if (this.isImage(download.url)) {
              return (
                <Paper className="image-thumb" key={index}>
                  <a href={download.url} target="_blank">
                    <img src={download.url} />
                    <figcaption>{download.title}</figcaption>
                  </a>
                </Paper>
              );
            } else if (this.isVideo(download.url)) {
              var extension = download.url.split('.').pop();
              return (
                <Paper className="image-thumb" key={index}>
                  <a href={download.url} target="_blank">
                    <VideoPreview
                      sources={[{ url: download.url, type: extension }]}
                    />
                    <figcaption>{download.title}</figcaption>
                  </a>
                </Paper>
              );
            } else {
              return (
                <div key={index} className="download-file">
                  <a href={download.url} target="_blank">
                    <i className={'md md-cloud'} />
                    {download.title}
                  </a>
                </div>
              );
            }
          })}
        </div>
      );
    }

    let body, confirmDialog;
    if (this.state.confirmDialog) {
      const standardActions = [
        <FlatButton
          key="cancel"
          label={this.context.getIntlMessage('No')}
          primary
          onTouchTap={this.cancelDelete}
        />,
        <FlatButton
          key="ok"
          label={this.context.getIntlMessage('Yes')}
          secondary
          onTouchTap={this.deleteConfirm}
        />
      ];

      confirmDialog = (
        <DialogPortal>
          <Dialog
            ref="confirmDialog"
            openImmediately
            title={this.context.getIntlMessage('Remove')}
            actions={standardActions}
            dismissOnClickAway
          >
            {this.context.getIntlMessage('post.confirmDelete')}
          </Dialog>
        </DialogPortal>
      );
    }
    if (this.state.mode === 'edit') {
      body = <EditBox value={this.state.body} onSave={this.onSave} />;
    } else {
      body = (
        <Linkify>
          <div style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.body.replace('\r', '<br />')}
          </div>
        </Linkify>
      );
    }
    return (
      <div>
        <a id={`post-${this.props.id}`} />
        <div
          className={ClassNames('post-wrapper', {
            'discussion-header': depth === 1
          })}
        >
          {!this.props.noUser && (
            <div className="profile">
              <ProfileImage author={this.props.author} />
            </div>
          )}
          <div className="post">
            <div
              className={ClassNames({
                'arrow-box': !this.props.noUser,
                'message-box': this.props.noUser,
                light: this.props.author && depth > 1 && this.props.user.id !== this.props.author.id,
                dark: this.props.author &&  this.props.user.id === this.props.author.id && depth > 1
              })}
            >
              {controls}
              {body}
              {downloads}
            </div>
          </div>
        </div>
          {this.props.author && this.props.author.id === this.props.user.id && this.state.messages.length > 0 && (
              <RaisedButton
                  style={{
                      marginLeft: 70,
                      width: 'calc(100% - 70px)',
                      marginBottom: 16,
                      minWidth: 'auto'
                  }}
                  onClick={this.onSortMessage}
                  fullWidth={true}
                  backgroundColor="rgb(255, 255, 255)"
                  labelColor="#000"
                  label={this.context.getIntlMessage('SortMessages')}
              />
          )}
        {messages}
        {composer}
        {this.props.author && this.props.author.id === this.props.user.id && this.state.messages.length > 0 && (
            <RaisedButton
              style={{
                marginLeft: 70,
                width: 'calc(100% - 70px)',
                marginBottom: 16,
                minWidth: 'auto'
              }}
              onClick={() => this.onRemove(this.props.id, true)}
              fullWidth
              label="Remove all attached files"
            />
          )}
        {confirmDialog}
      </div>
    );
  }
});

class EditBox extends Component {
  static propTypes = {
    value: PropTypes.string,
    onSave: PropTypes.func
  };

  componentDidMount() {
    const { textField } = this.refs;
    const inputField = textField._getInputNode();
    const value = textField.getValue();
    textField.focus();
    textField.setValue(value);
    inputField.select();
  }

  save() {
    if (this.props.onSave) {
      const value = this.refs.textField.getValue();
      this.props.onSave(value);
    }
  }

  render() {
    return (
      <div style={styles.editBox}>
        <TextField
          ref="textField"
          fullWidth
          defaultValue={this.props.value}
          multiLine
        />
        <RaisedButton
          secondary
          fullWidth
          label={'Save'}
          onTouchTap={this.save.bind(this)}
        />
      </div>
    );
  }
}

class DiscussionModule extends PageModule {
  static displayName = 'DiscussionModule';

  constructor() {
    super(...arguments);
    const { content, params } = this.props;
    const fileObjects = (content.objects && content.objects.files) || [];
    const fileIds = (content.objects && content.objects.file) || [];

    const files = fileObjects.map((file, index) => {
      return {
        id: fileIds[index],
        title: file.title,
        url: file.url
      };
    });

    this.state = {
      body: content.body,
      files: files
    };
  }

  onChange(message, uploads) {
    this.setState({ body: message, files: uploads });
  }

  saveOnBlur() {
    MessageService.info(this.context.getIntlMessage('video.changesSaved'));
    this.save(false);
  }

  save(switchBack = true) {
    const message = this.state.body;
    const { files } = this.state;
    const originalMessage = this.props.content;
    const { params } = this.props;
    const originalMessageId = originalMessage.id || params.post_id;
    Post.update(originalMessageId, message, files, response => {
      this.setState({ body: response.data.body, files: response.data.files });
    });
    if (switchBack) {
      this.changeToDetailMode();
    }
  }

  renderDetailMode(content, data) {
    const { user, editor, themeColor, gaTracking } = this.props;
    const { author: mainAuthor } = content;
    const messageId = content.id || data.post_id;
    const { files, body } = this.state;

    return (
      <div
        style={{ padding: Spacing.desktopGutterMini }}
        className="discussion-module"
      >
        <Message
          themeColor={themeColor}
          noUser
          editor={editor}
          replyEnabled
          user={user}
          depth={0}
          messages={content.children}
          body={body}
          id={messageId}
          isFollowing={content.isFollowing}
          created={content.created}
          author={mainAuthor}
          files={files}
          gaTracking={gaTracking}
        />
      </div>
    );
  }

  renderEditMode() {
    const { user, themeColor } = this.props;
    const { files, body } = this.state;
    return (
      <div
        style={{ padding: Spacing.desktopGutterMini }}
        className="discussion-module"
      >
        <MessageComposer
          themeColor={themeColor}
          noUser
          ref="composer"
          onChange={::this.onChange}
          saveOnBlur={::this.saveOnBlur}
          sendButton={false}
          message={body}
          files={files}
          author={user}
        />
      </div>
    );
  }
}

export default DiscussionModule;

// var Discussion = React.createClass({
//   mixins: [IntlMixin],
//   getDefaultProps() {
//     return {
//       content : {
//         objects : {
//           files: []
//         }
//       }
//     };
//   },
//   getInitialState() {
//     var files = [],
//         fileObjects = this.props.content && this.props.content.objects && this.props.content.objects.files || [],
//         fileIds = this.props.content && this.props.content.objects && this.props.content.objects.file || [];
//     for (var i = 0; i < fileObjects.length; i++) {
//       files.push({id: fileIds[i], title: fileObjects[i].title, url: fileObjects[i].url});
//     }
//     return {
//       body: this.props.content.body || '',
//       files: files,
//     };
//   },
//   _onChange(message, uploads) {
//     this.setState({body: message, files:uploads});
//   },
//   save() {
//     var message = this.state.body,
//         uploads = this.state.files,
//         originalMessage = this.props.content,
//         params = this.props.params,
//         originalMessageId = originalMessage.id || params.post_id;
//     Post.update(originalMessageId, message, uploads, response => {
//       var fileIds = response.data.files.map(file => {
//         return file.id;
//       });
//       this.setState({body: response.data.body, files: response.data.files})
//     });
//   },
//   delete() {
//     this.refs.confirmDialog.show();
//   },
//   confirmDelete() {
//     Page.deletePageModule(this.props.moduleId, response => {
//       CourseActions.getPageById(this.props.pageId);
//     });
//   },

//   render() {
//     var {content, ...other} = this.props, classes, standardActions;
//     classes = ClassNames(this.props.className, this.props.mode + '-mode');
//     standardActions = [
//       <FlatButton key='ok' label={this.getIntlMessage('OK')} secondary={true} className='full' onTouchTap={this.confirmDelete} />
//     ];

//     if (this.props.mode == 'edit') {
//       content = this.renderEditMode();
//     } else {
//       content = this.renderDetailMode();
//     }
//     return (
//       <div {...other} className={classes}>
//         {content}
//         {this.props.children}
//         <Dialog
//           ref="confirmDialog"
//           title={this.getIntlMessage('Remove')}
//           actions={standardActions}
//           dismissOnClickAway={true}>
//           {this.getIntlMessage('discussion.confirmDelete')}
//         </Dialog>
//       </div>
//     );
//   }

// });

// module.exports = Discussion;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Discussion.js